// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
var IosWebPage = /* #__PURE__ */ (function () {
    function IosWebPage() {

    };
    IosWebPage.value = new IosWebPage();
    return IosWebPage;
})();
var IosMobileApp = /* #__PURE__ */ (function () {
    function IosMobileApp() {

    };
    IosMobileApp.value = new IosMobileApp();
    return IosMobileApp;
})();
var getMobileAppType = function __do() {
    var appType = $foreign.getMobileAppTypeImpl();
    if (appType === "IosWebPage") {
        return new Data_Maybe.Just(IosWebPage.value);
    };
    if (appType === "IosMobileApp") {
        return new Data_Maybe.Just(IosMobileApp.value);
    };
    return Data_Maybe.Nothing.value;
};
var eqAppType = {
    eq: function (x) {
        return function (y) {
            if (x instanceof IosWebPage && y instanceof IosWebPage) {
                return true;
            };
            if (x instanceof IosMobileApp && y instanceof IosMobileApp) {
                return true;
            };
            return false;
        };
    }
};
export {
    isMobileApp,
    isInIframe,
    mobileGeolocationEnabled
} from "./foreign.js";
export {
    getMobileAppType,
    IosWebPage,
    IosMobileApp,
    eqAppType
};
//# sourceMappingURL=index.js.map
